import { getVimeoIdFromUrl } from "./getVimeoIdFromUrl"

export const isVimeoVideoURL = (value: string) => {
  return !!getVimeoIdFromUrl(value)
}
